import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = entry.boundingClientRect.bottom < 0;
      setVisible(!entry.isIntersecting && passed);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-105" data-mp="2fsbf9cuk9glv">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.28,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/30 bg-navy-deep/95 px-3 py-3 backdrop-blur-sm" data-id="element-106" data-mp="2awctzy4j4epo">
          <div className="mx-auto flex w-full max-w-xl items-center gap-3" data-id="element-107" data-mp="2z2r44brq076i">
            <div className="hidden shrink-0 leading-tight sm:block" data-id="element-108" data-mp="332hsy9xosd8e">
              <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-white/50" data-id="element-109" data-mp="2pco1rkyplgvi">
                Precio hoy
              </p>
              <p className="font-display text-xl font-bold text-gold" data-id="element-110" data-mp="2u9o9s1f4ctp9">USD $13.99</p>
            </div>
            <a href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-2 rounded-xl bg-gold px-4 py-3.5 text-sm font-extrabold uppercase tracking-wide text-navy-deep transition-colors hover:bg-gold-light sm:text-base" data-id="element-111" data-mp="2fcf380h8vjcy">
              Quiero mi acceso por USD $13.99
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-112" data-mp="2be7vtw8o7uef" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}